const resource = '/admin/v1/request-ebooks';

export default $axios => ({
  index(payload) {
    return $axios.post(`${resource}/search`, payload);
  },
  updateStatus(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },
});
